import { Types as TYPES } from '../types';
import { Endpoints as ENDPOINTS } from '../endpoints';
import {
    decryptAllFormData,
    decryptSingleFormData,
} from '../../utils/crypt-module/decrypt';
import { useAuth as Auth_Util } from '../../custom-hooks/useAuth';
import { sendRegistrationNotification } from '../actions/notification-action';
import Swal from 'sweetalert2';

const { getPrivateKey } = Auth_Util();

const actionType = TYPES.find((type) => type.actionName === 'dashboardAction');
const {
    ALL_PARTICIPANT_FETCH_START,
    ALL_PARTICIPANT_FETCH_SUCCESS,
    ALL_PARTICIPANT_FETCH_FAILED,
    ALL_PARTICIPANT_FETCH_STOP,
    ALL_PARTICIPANT_FETCH_EMPTY,

    SINGLE_PARTICIPANT_FETCH_START,
    SINGLE_PARTICIPANT_FETCH_SUCCESS,
    SINGLE_PARTICIPANT_FETCH_FAILED,
    SINGLE_PARTICIPANT_FETCH_STOP,

    PARTICIPANT_CREATE_START,
    PARTICIPANT_CREATE_SUCCESS,
    PARTICIPANT_CREATE_FAILED,
    PARTICIPANT_CREATE_STOP,

    PARTICIPANT_UPDATE_START,
    PARTICIPANT_UPDATE_SUCCESS,
    PARTICIPANT_UPDATE_FAILED,
    PARTICIPANT_UPDATE_STOP,

    PARTICIPANT_DELETE_START,
    PARTICIPANT_DELETE_SUCCESS,
    PARTICIPANT_DELETE_FAILED,
    PARTICIPANT_DELETE_STOP,

    PARTICIPANT_ARCHIVE_START,
    PARTICIPANT_ARCHIVE_FAILED,
    PARTICIPANT_ARCHIVE_SUCCESS,
    PARTICIPANT_ARCHIVE_STOP,

    PARTICIPANT_UNARCHIVE_START,
    PARTICIPANT_UNARCHIVE_FAILED,
    PARTICIPANT_UNARCHIVE_STOP,
    PARTICIPANT_UNARCHIVE_SUCCESS,
} = actionType.types;

const { baseUrl, routes } = ENDPOINTS;

export const dashboardActions = {
    allParticipantAction: (param) => (dispatch) => {
        dispatch({
            type: ALL_PARTICIPANT_FETCH_START,
        });

        const { token } = param;

        const allParticipantUrl = `${baseUrl}${routes.get.participant}`;

        fetch(allParticipantUrl, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        })
            .then((resp) => resp.json())
            .then((res) => {
                if (res && Array.isArray(res.data) && res.data.length > 0) {
                    const privateKey = getPrivateKey();

                    decryptAllFormData(res.data, privateKey).then(
                        (decryptedData) => {
                            if (
                                decryptedData &&
                                decryptedData.isDecrypted === undefined
                            ) {
                                dispatch({
                                    type: ALL_PARTICIPANT_FETCH_SUCCESS,
                                    payload: decryptedData,
                                });
                            } else if (
                                decryptedData &&
                                decryptedData.isDecrypted !== undefined &&
                                !decryptedData.isDecrypted
                            ) {
                                Swal.fire({
                                    title: 'Decryption failed',
                                    text: 'Error decrypting data',
                                    icon: 'error',
                                });
                                dispatch({
                                    type: ALL_PARTICIPANT_FETCH_FAILED,
                                });
                            }
                        }
                    );
                } else {
                    dispatch({
                        type: ALL_PARTICIPANT_FETCH_EMPTY,
                    });
                }
            })
            .catch((e) => {
                dispatch({
                    type: ALL_PARTICIPANT_FETCH_FAILED,
                });
            });
    },

    singleParticipantAction: (params) => (dispatch) => {
        dispatch({
            type: SINGLE_PARTICIPANT_FETCH_START,
        });

        const { token, id } = params;
        const singleParticipantUrl = `${baseUrl}${routes.get.participant}/${id}`;

        fetch(singleParticipantUrl, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${token}`,
            },
        })
            .then((resp) => resp.json())
            .then((res) => {
                const privateKey = getPrivateKey();

                decryptSingleFormData(res.data, privateKey).then(
                    (decryptedData) => {
                        if (
                            decryptedData &&
                            decryptedData.isDecrypted === undefined
                        ) {
                            dispatch({
                                type: SINGLE_PARTICIPANT_FETCH_SUCCESS,
                                payload: decryptedData,
                            });
                        } else if (
                            decryptedData &&
                            decryptedData.isDecrypted !== undefined &&
                            !decryptedData.isDecrypted
                        ) {
                            Swal.fire({
                                title: 'Decryption failed',
                                text: 'Error decrypting data',
                                icon: 'error',
                            });
                        }
                    }
                );
            })
            .catch((e) => {
                dispatch({
                    type: SINGLE_PARTICIPANT_FETCH_FAILED,
                });
            });
    },
    participantCreateAction: (params, emailData) => (dispatch) => {
        dispatch({
            type: PARTICIPANT_CREATE_START,
        });

        const participantCreateUrl = `${baseUrl}${routes.post.participant}`;

        fetch(participantCreateUrl, {
            method: 'POST',
            body: JSON.stringify(params),
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((resp) => resp.json())
            .then((res) => {
                dispatch({
                    type: PARTICIPANT_CREATE_SUCCESS,
                    payload: res,
                });

                //Send notification to participant::

                dispatch(
                    sendRegistrationNotification({
                        first_name: emailData.first_name,
                        email: emailData.email,
                    })
                );
            })
            .catch((e) => {
                dispatch({
                    type: PARTICIPANT_CREATE_FAILED,
                });
            });
    },
    participantUpdateAction: (params) => (dispatch) => {
        if (!params || !params.id || !params.token) {
            dispatch({
                type: PARTICIPANT_UPDATE_FAILED,
                error: 'Invalid parameters',
            });
            return;
        }

        dispatch({ type: PARTICIPANT_UPDATE_START });

        const { id, token } = params;

        const participantUpdateUrl = `${baseUrl}${routes.update.participant}/${id}`;

        fetch(participantUpdateUrl, {
            method: 'PUT',
            credentials: 'same-origin',
            body: JSON.stringify(params),
            redirect: 'follow',
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        })
            .then((resp) => {
                return resp.json();
            })
            .then((res) => {
                const privateKey = getPrivateKey();

                decryptSingleFormData(res.data, privateKey).then(
                    (decryptedData) => {
                        if (
                            decryptedData &&
                            decryptedData.isDecrypted === undefined
                        ) {
                            dispatch({
                                type: PARTICIPANT_UPDATE_SUCCESS,
                                payload: decryptedData,
                            });
                        } else if (
                            decryptedData &&
                            decryptedData.isDecrypted !== undefined &&
                            !decryptedData.isDecrypted
                        ) {
                            Swal.fire({
                                title: 'Decryption failed',
                                text: 'Error decrypting data',
                                icon: 'error',
                            });
                        }
                    }
                );
            })
            .catch((error) => {
                dispatch({
                    type: PARTICIPANT_UPDATE_FAILED,
                    error: error.message || 'Unknown error',
                });
            });
    },
    participantaArchiveAction: (params) => (dispatch) => {
        if (!params || !params.id || !params.token) {
            dispatch({
                type: PARTICIPANT_ARCHIVE_FAILED,
                error: 'Invalid parameters',
            });
            return;
        }

        dispatch({ type: PARTICIPANT_ARCHIVE_START });

        const { token } = params;

        const archiveParticipantUrl = `${baseUrl}${routes.others.archive}`;

        fetch(archiveParticipantUrl, {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify(params),
            redirect: 'follow',
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        })
            .then((resp) => {
                return resp.json();
            })
            .then((res) => {
                dispatch({
                    type: PARTICIPANT_ARCHIVE_SUCCESS,
                    payload: res,
                });
            })
            .catch((error) => {
                dispatch({
                    type: PARTICIPANT_ARCHIVE_FAILED,
                    error: error.message || 'Unknown error',
                });
            });
    },

    participantDeleteAction: (params) => (dispatch) => {
        dispatch({ type: PARTICIPANT_DELETE_START });

        const { id, token } = params;
        const deleteUserUrl = `${baseUrl}${routes.delete.participant}/${id}`;

        fetch(deleteUserUrl, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        })
            .then((resp) => resp.json())
            .then((res) => {
                if (res.success) {
                    dispatch({
                        type: PARTICIPANT_DELETE_SUCCESS,
                        payload: res.data,
                    });
                } else {
                    dispatch({
                        type: PARTICIPANT_DELETE_FAILED,
                    });
                }
            })
            .catch((e) => {
                dispatch({
                    type: PARTICIPANT_DELETE_FAILED,
                });
            });
    },
};
